import React, { useEffect, useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const CustomerLogos = ({ lang }) => {
	const [currentOneIndex, setCurrentOneIndex] = useState(0);
	const [currentTwoIndex, setCurrentTwoIndex] = useState(0);
	const [currentThreeIndex, setCurrentThreeIndex] = useState(0);
	const [currentFourIndex, setCurrentFourIndex] = useState(0);
	const [currentFiveIndex, setCurrentFiveIndex] = useState(0);
	const [currentSixIndex, setCurrentSixIndex] = useState(0);

	const animation = () => {
		let index = currentOneIndex + 1;

		if (index > 1) {
			index = 0;
		}

		setTimeout(() => setCurrentOneIndex(-1), 500);
		setTimeout(() => setCurrentTwoIndex(-1), 700);
		setTimeout(() => setCurrentThreeIndex(-1), 900);
		setTimeout(() => setCurrentFourIndex(-1), 1100);
		setTimeout(() => setCurrentFiveIndex(-1), 1300);
		setTimeout(() => setCurrentSixIndex(-1), 1500);

		setTimeout(() => setCurrentOneIndex(index), 600);
		setTimeout(() => setCurrentTwoIndex(index), 800);
		setTimeout(() => setCurrentThreeIndex(index), 1000);
		setTimeout(() => setCurrentFourIndex(index), 1200);
		setTimeout(() => setCurrentFiveIndex(index), 1400);
		setTimeout(() => setCurrentSixIndex(index), 1600);
	};

	useEffect(() => {
		const interval = setInterval(animation, 5000);

		return () => clearInterval(interval);
	}, [currentOneIndex]);
	// }, [currentOneIndex, currentTwoIndex, currentThreeIndex, currentFourIndex, currentFiveIndex, currentSixIndex])

	return (
		<div className="main__section">
			<div className="container container--np">
				<div className="carousel-logos">
					{lang === 'en' ? (
						<>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentOneIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/santander.svg'}
										alt="santander"
										placeholder="blurred"
										title="santander"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentOneIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/orange.svg'}
										alt="orange"
										title="orange"
										placeholder="blurred"
									/>
								</div>
							</div>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentTwoIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/02.svg'}
										alt="o2"
										title="o2"
										placeholder="blurred"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentTwoIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/adecco.svg'}
										alt="adecco"
										title="adecco"
										placeholder="blurred"
									/>
								</div>
							</div>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentThreeIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/renfe.svg'}
										alt="renfe"
										title="renfe"
										placeholder="blurred"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentThreeIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/habitissimo.svg'}
										alt="habitissimo"
										title="habitissimo"
										placeholder="blurred"
									/>
								</div>
							</div>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentFourIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/cms.svg'}
										alt="cms"
										title="cms"
										placeholder="blurred"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentFourIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/reental.svg'}
										alt="reental"
										title="reental"
										placeholder="blurred"
									/>
								</div>
							</div>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentFiveIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/wolo.svg'}
										alt="wolo"
										title="wolo"
										placeholder="blurred"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentFiveIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/prosegur.svg'}
										alt="prosegur"
										title="prosegur"
										placeholder="blurred"
									/>
								</div>
							</div>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentSixIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/finastra.svg'}
										alt="finastra"
										title="finastra"
										placeholder="blurred"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentSixIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/EN/software-one.svg'}
										alt="software-one"
										title="software-one"
										placeholder="blurred"
									/>
								</div>
							</div>
						</>
					) : (
						<>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentOneIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/santander.svg'}
										alt="santander"
										title="santander"
										placeholder="blurred"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentOneIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/masorange.svg'}
										alt="masorange"
										title="masorange"
										placeholder="blurred"
									/>
								</div>
							</div>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentTwoIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/telefonica.svg'}
										alt="telefonica"
										title="telefonica"
										placeholder="blurred"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentTwoIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/cms.svg'}
										alt="cms"
										title="cms"
										placeholder="blurred"
									/>
								</div>
							</div>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentThreeIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/dominion.svg'}
										alt="dominion"
										title="dominion"
										placeholder="blurred"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentThreeIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/habitissimo.svg'}
										alt="habitissimo"
										title="habitissimo"
										placeholder="blurred"
									/>
								</div>
							</div>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentFourIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/renfe.svg'}
										alt="renfe"
										title="renfe"
										placeholder="blurred"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentFourIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/reental.svg'}
										alt="reental"
										title="reental"
										placeholder="blurred"
									/>
								</div>
							</div>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentFiveIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/alquiler-seguro.svg'}
										alt="alquiler-seguro"
										title="alquiler-seguro"
										placeholder="blurred"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentFiveIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/bip&drive.svg'}
										alt="bip&drive"
										title="bip&drive"
										placeholder="blurred"
									/>
								</div>
							</div>
							<div className="carousel-logos__customers">
								<div
									className={`carousel-logos__customers__logo ${
										currentSixIndex === 0 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/ibercaja.svg'}
										alt="ibercaja"
										title="ibercaja"
										placeholder="blurred"
									/>
								</div>
								<div
									className={`carousel-logos__customers__logo ${
										currentSixIndex === 1 ? 'carousel-logos__customers__logo--show' : ''
									}`}
								>
									<StaticImage
										src={'../../../new/resources/home/clients/ES/gobierno-asturias.svg'}
										alt="gobierno-asturias"
										title="gobierno-asturias"
										placeholder="blurred"
									/>
								</div>
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default CustomerLogos;
